import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import Svg, { Path } from 'react-native-svg';
function SvgComponent(props) {
  var color = props.color;
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement(Path, {
    d: "M11.96 9.267a.667.667 0 11-1.333 0 .667.667 0 011.333 0z",
    fill: color !== null && color !== void 0 ? color : '#000',
    fillOpacity: 0.87
  }), /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.228 3A2.567 2.567 0 001.667 5.57c0 1.026.598 1.912 1.464 2.325.332.158.704.247 1.097.247A2.567 2.567 0 006.79 5.57 2.566 2.566 0 004.228 3zM.867 5.57A3.367 3.367 0 014.228 2.2c1.142 0 2.15.571 2.758 1.443l4.188-.782a1.44 1.44 0 011.704 1.415v.895h.176c.604 0 1.093.49 1.093 1.094v6.042c0 .604-.49 1.093-1.093 1.093H3.652c-.604 0-1.093-.49-1.093-1.093V8.498A3.372 3.372 0 01.867 5.571zM3.359 8.83v3.478c0 .162.131.293.293.293h9.402a.293.293 0 00.293-.293V6.265a.293.293 0 00-.293-.294H7.566A3.366 3.366 0 013.36 8.83zM7.566 5.17h4.512v-.895a.64.64 0 00-.758-.629l-3.945.737c.094.25.159.514.191.787zM4.228 3.685c.221 0 .4.18.4.4v1.086h1.08a.4.4 0 110 .8h-1.48a.4.4 0 01-.4-.4V4.085c0-.22.18-.4.4-.4z",
    fill: color !== null && color !== void 0 ? color : '#000',
    fillOpacity: 0.87
  }));
}
export default SvgComponent;